export default "__VITE_ASSET__C3bxaD6S__"